/**
 * A visão PADRÃO da mesa — a que ela abre sem `?visao=`.
 *
 * Módulo puro (sem React, sem DOM além do `localStorage`) pelo mesmo motivo de
 * `avisos.js`: é regra que se testa sozinha, e que a vista só consome.
 *
 * No navegador e não no banco, como a coluna recolhida e o detalhe do filtro da
 * mesa: é preferência de quem está olhando, não dado do escritório — e quem
 * atende num computador e confere no tablet costuma querer coisas diferentes nos
 * dois.
 */

/** Os ids das quatro visões. A vista acrescenta rótulo e ícone; a ORDEM é a dela. */
export const IDS_DAS_VISOES = ["resumo", "painel", "kanban", "tabela"];

export const VISAO_DE_FABRICA = "resumo";

const CHAVE = "mesa.visao.padrao";

/*
 * `try` em tudo porque `localStorage` ATIRA em contexto sem site data (janela
 * privada, navegador configurado para bloquear, captura de miniatura) — e a mesa
 * não pode deixar de abrir por causa de uma preferência de visão.
 */
export function lerVisaoPadrao() {
  try {
    const salva = localStorage.getItem(CHAVE);
    /* Visão que não existe mais (renomeada, removida) cai no padrão de fábrica:
       preferência velha não pode deixar a mesa sem tela. */
    return IDS_DAS_VISOES.includes(salva) ? salva : VISAO_DE_FABRICA;
  } catch {
    return VISAO_DE_FABRICA;
  }
}

export function salvarVisaoPadrao(id) {
  try {
    if (id === VISAO_DE_FABRICA) localStorage.removeItem(CHAVE);
    else localStorage.setItem(CHAVE, id);
  } catch {
    /* navegador sem storage: só não lembra na próxima abertura */
  }
}
